export enum DataValues  {
  WHATSAPP = 'WhatsApp',
  WHATSAPP_MESSAGE = 'Mensaje WhatsApp',
  EMAIL = "Correo",
  YOUTUBE= 'Youtube',
  INSTAGRAM= 'Instagram',
  COMPANY_NAME = 'Nombre de Empresa'
}
